import React from "react";
import { UiLink } from "../../_uiComponents/common/UiLink";
import { UiNextArrow } from "../../_uiComponents/common/UiSliderArrows";

export const UiInfoCard = (props) => {
    return (
        <>
            <div className="sb-info-card">
                <div className="sb-info-card__header">
                    <div>
                        <h2>{props.title}</h2>
                        <h3>{props.subtitle}</h3>
                    </div>
                </div>
                <div className="sb-info-card__content">
                    <div className="sb-info-card__content__points">
                        {props.contentTitle && <h5>{props.contentTitle}</h5>}

                        {props.children}
                        {props.footer && (
                            <div className="sb-info-card__content__points__footer">
                                {props.linkTitle && (
                                    <UiLink
                                        title={props.linkTitle}
                                        to={props.LinkTo}
                                        icon={<UiNextArrow />}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
